import { render, staticRenderFns } from "./FacebookLogoutModal.vue?vue&type=template&id=10f21dbb&scoped=true&"
import script from "./FacebookLogoutModal.vue?vue&type=script&lang=js&"
export * from "./FacebookLogoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f21dbb",
  null
  
)

export default component.exports